"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStatusAnimationPoller = void 0;
var _react = require("react");
// TODO: Figure out where we can codegen these types from lottie-files

const useStatusAnimationPoller = ({
  status = 'loading',
  playMarkers,
  onFinish
}) => {
  const isRunning = (0, _react.useRef)(false);
  const isComplete = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    // Play loading animation on mount if we aren't already running
    if (!isRunning.current && !!playMarkers) {
      playMarkers('loadingStart', 'loadingEnd');
      isRunning.current = true;
    }
  }, [playMarkers]);
  const previousStatusRef = (0, _react.useRef)();

  // onAnimationFinish will get triggered after our first useEffect
  // play completes and then after each play within onAnimationFinish completes.
  return (0, _react.useCallback)(() => {
    const previousStatus = previousStatusRef.current;
    if (status === 'loading') {
      playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('loadingStart', 'loadingEnd');
    } else if (status === 'pending') {
      if (previousStatus === 'pending') {
        playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('pendingAltLoopStart', 'pendingAltLoopEnd');
      } else {
        playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('pendingAltStart', 'pendingAltEnd');
      }
    } else if (!isComplete.current) {
      switch (status) {
        case 'success':
          {
            if (previousStatus === 'pending') {
              playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('successAltStart', 'successAltEnd');
            } else {
              playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('successStart', 'successEnd');
            }
            break;
          }
        case 'cardSuccess':
          {
            playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('successCardStart', 'successCardEnd');
            break;
          }
        case 'failure':
          {
            if (previousStatus === 'pending') {
              playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('failureAltStart', 'failureAltEnd');
            } else {
              playMarkers === null || playMarkers === void 0 ? void 0 : playMarkers('failureStart', 'failureEnd');
            }
            break;
          }
        default:
          break;
      }
      isComplete.current = true;
      onFinish === null || onFinish === void 0 ? void 0 : onFinish();
    }
    previousStatusRef.current = status;
  }, [onFinish, playMarkers, status]);
};
exports.useStatusAnimationPoller = useStatusAnimationPoller;